import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoaderService {
    private readonly _loading = new BehaviorSubject<boolean>(false);
    private requestCount = 0;

    get loading$(): Observable<boolean> {
        return this._loading.asObservable();
    }

    get isLoading(): boolean {
        return this._loading.getValue();
    }

    show(): void {
        this.requestCount++;
        this.emitLoadingState();
    }

    hide(): void {
        if (this.requestCount > 0) {
            this.requestCount--;
        }
        this.emitLoadingState();
    }

    setLoading(value: boolean): void {
        if (value) {
            this.show();
        } else {
            this.hide();
        }
    }

    reset(): void {
        this.requestCount = 0;
        this.emitAsync(false);
    }

    private emitLoadingState(): void {
        this.emitAsync(this.requestCount > 0);
    }

    private emitAsync(value: boolean): void {
        Promise.resolve().then(() => {
            this._loading.next(value);
        });
    }
}
